import { Injectable } from '@angular/core';
import { FormModeEnum } from 'beyond-util';
import { forEach } from '@angular/router/src/utils/collection';

@Injectable()
export class UtilServiceClient {
  constructor() {}

  isEmptyGuid(guid: string): boolean {
    return '00000000-0000-0000-0000-000000000000' === guid;
  }

  parseEnum(data: Array<any>, label?: string, value?: string): any[] {
    return data.map(d => {
      return {
        value: value ? d.value : d.Id,
        label: label ? d[label] : d.Naziv,
      };
    });
  }

  deepCopy(toCopy: any): any {
    return JSON.parse(JSON.stringify(toCopy));
  }

  distinctBy(array: any[], prop: string) {
    const unique = [];
    const distinct = [];
    array.forEach(x => {
      if (!unique[x[prop]]) {
        distinct.push(x);
        unique[x[prop]] = 1;
      }
    });

    return distinct;
  }

  distinct(array: any[]) {
    return Array.from(new Set(array));
  }

  getName(
    order: any,
    mode,
    newEntityName: string,
    listEntityName: string
  ): string {
    let name;

    if (typeof order === 'undefined') {
      return name;
    }

    if (order.hasOwnProperty('naziv')) {
      name = order.naziv;
    } else if (mode === FormModeEnum.Add) {
      name = newEntityName;
    } else if (order.hasOwnProperty('id')) {
      name = listEntityName;
    }

    return name;
  }

  isPropertyNull(myObject, property) {
    return Object.keys(myObject).every(key => {
      if (property === key) {
        console.log(myObject[key]);

        return myObject[key] === null;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/util.service.ts